/**
 * Option Plus dropdown placeholder fix
 * ---------------------------------------------------------------------------
 * The Option Plus app renders each searchable dropdown's search input with
 * placeholder="Search {Option Title}...". This only rewrites that placeholder
 * text to "Select {Option Title}" — the app's search/filter behavior on
 * .dropdown-search is left completely untouched.
 */
(() => {
  const CONTAINER_ID = 'optionPlusvariant-container';
  const SEARCH_INPUT_SELECTOR = '.searchable-dropdown[data-title] .dropdown-search';

  function fixPlaceholder(input) {
    const title = input.closest('.searchable-dropdown')?.dataset.title;
    if (!title) return;

    const desired = `Select ${title}`;
    if (input.placeholder !== desired) {
      input.placeholder = desired;
    }
  }

  function fixAll(container) {
    container.querySelectorAll(SEARCH_INPUT_SELECTOR).forEach(fixPlaceholder);
  }

  function attach(container) {
    fixAll(container);

    const observer = new MutationObserver(() => fixAll(container));
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['placeholder'],
    });
  }

  function init() {
    const existing = document.getElementById(CONTAINER_ID);
    if (existing) {
      attach(existing);
      return;
    }

    const bodyObserver = new MutationObserver(() => {
      const container = document.getElementById(CONTAINER_ID);
      if (container) {
        bodyObserver.disconnect();
        attach(container);
      }
    });
    bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
